/**
 * Utilidad para construir rutas internas de navegación según el tipo de resultado de búsqueda global
 * 
 * Esta función mapea cada tipo de resultado a su ruta correspondiente en la aplicación,
 * basándose en las rutas definidas en protectedRoutes.tsx
 * 
 * @param type - Tipo de resultado de búsqueda
 * @param id - ID del elemento
 * @param statusName - Estado del elemento (opcional, usado para returned_reception)
 * @param code - Código del elemento (opcional, usado para location y cart)
 * @returns Ruta interna de la aplicación
 */
import type { GlobalSearchResult } from '../models/GlobalSearch';
import { ReturnedStatus } from '@modules/Returned/List/config/returnedConfig';

export const getGlobalSearchRoute = (
  type: GlobalSearchResult['type'],
  id: string | number,
  statusName?: string | number | null,
  code?: string
): string => {
  const idStr = String(id);

  switch (type) {
    case 'product':
      // Productos: ruta de edición
      return `/products/edit/${idStr}`;

    case 'order':
      // Órdenes: ruta de visualización
      return `/orders/view/${idStr}`;

    case 'merchandise':
      // Mercancías: ruta de edición (alternativa: /merchandise/view-entry/${idStr} para recepción)
      return `/merchandise/${idStr}/edit`;

    case 'location':
      // Ubicaciones: lista con búsqueda por código
      if (code) {
        return `/locations?search=${encodeURIComponent(code)}`;
      }
      return '/locations';

    case 'cart':
      // Carros: lista con búsqueda por código
      if (code) {
        return `/carts?search=${encodeURIComponent(code)}`;
      }
      return '/carts';

    case 'preparation':
      // Preparaciones: ruta de picking para ver detalles
      return `/order-preparation/picking/${idStr}`;

    case 'returned_reception':
      // Recepciones devueltas: según el estado
      // Si statusName es 2 (PENDING), usar /locate, sino /receive
      if (typeof statusName === 'number' && statusName === ReturnedStatus.PENDING) {
        return `/returned/${idStr}/locate`;
      }
      return `/returned/${idStr}/receive`;

    default:
      // Fallback: ruta a home
      return '/home';
  }
};

